// IOHB-1868: check boxes that share one name but stand for different answers (e.g. a "Yes" box and a "No" box).
// pdf-lib's check() always ticks such a field's first box and isChecked() only recognises that box, so these read
// and write the box by its export value instead. `field` is a pdf-lib PDFCheckBox.

const boxesOf = (field: any): any[] => {
  const acroField = field?.acroField;
  return typeof acroField?.getWidgets === 'function' ? acroField.getWidgets() : [];
};

const textOf = (pdfName: any): string | undefined =>
  pdfName && typeof pdfName.decodeText === 'function' ? pdfName.decodeText() : undefined;

/** The export values of a check box's boxes, without repeats. More than one means the boxes are different answers. */
export function checkBoxExportValues(field: any): string[] {
  const values: string[] = [];
  for (const box of boxesOf(field)) {
    const value = textOf(box?.getOnValue?.());
    if (value !== undefined && !values.includes(value)) values.push(value);
  }
  return values;
}

/** The export value of the box that is ticked, or false when none is. */
export function tickedCheckBoxExportValue(field: any): string | false {
  const value = textOf(field?.acroField?.getValue?.());
  return value !== undefined && value !== 'Off' && checkBoxExportValues(field).includes(value) ? value : false;
}

/** Ticks the box whose export value is `exportValue` and clears the field's other boxes. Returns false, changing
 *  nothing, when no box has that export value. */
export function tickCheckBoxByExportValue(field: any, exportValue: string): boolean {
  const PDFName = (window as any).PDFLib?.PDFName;
  const boxes = boxesOf(field);
  const onValue = boxes.map((box) => box?.getOnValue?.()).find((on) => on !== undefined && textOf(on) === exportValue);
  if (!PDFName || onValue === undefined) return false;
  field.acroField.dict.set(PDFName.of('V'), onValue);
  boxes.forEach((box) => box.setAppearanceState(box.getOnValue?.() === onValue ? onValue : PDFName.of('Off')));
  if (typeof field.markAsDirty === 'function') field.markAsDirty();
  return true;
}
